import styled from 'styled-components';

import {grey} from '@drivesally/sally-ui/lib/libs/colors';

const NewTeamRow = styled.div`
  align-items: center;
  border-bottom: 1px solid ${grey};
  display: flex;
  flex-shrink: 0;
  gap: 8px;
  padding: 12px 20px;
`;

export default NewTeamRow;
